import { LicenseManager, AllEnterpriseModule } from 'ag-grid-enterprise';
import { ModuleRegistry } from 'ag-grid-community';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

ModuleRegistry.registerModules([AllEnterpriseModule]);

LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-119944}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Johnson,_Mirmiran_&_Thompson,_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{12}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{5_March_2027}____[v3]_[01]_MTgwNDIwNDgwMDAwMA==6c1330a8ee065d68e6798c34761fd0f2");

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
